import React, { useState } from 'react'
import { AgChartsReact } from 'ag-charts-react';

const AppointmentsChart = ({ data }) => {
  const chartData = {
    data: data,
    series: [{ type: 'bar', xKey: 'month', yKey: 'appointments' }],
  }

  return (
    <AgChartsReact options={chartData} />
  );
}

export default AppointmentsChart;